<template>
    <div class="score-ruler" ref="scoreRuler">
        <div class="bar" ref="scoreRulerBar"></div>
        <div ref="scoreRulerPointer" class="bar-pointer" @mousedown="savePosition">
            <div class="score-show">
                {{ valueData }}
                <div class="score-show-arrow"></div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, nextTick } from "vue";
const props = defineProps({
    score: {
        type: [Number, String],
        default: 5,
    },
});
let scoreRuler = ref(null);
let scoreRulerBar = ref(null);
let scoreRulerPointer = ref(null);
// 计算 当前宽度距离左侧浏览器窗口的距离
let scoreRulerOffsetX = ref(0);
let rulerWidth = ref(0);
let onDrag = ref(false);
let valueData = ref(0); // 分值展示
nextTick(() => {
    scoreRulerOffsetX.value = scoreRuler.value.offsetLeft;
    rulerWidth.value = scoreRuler.value.offsetWidth;
});

const savePosition = (e) => {
    // 计算初始位置
    onDrag.value = true;
};
window.onmousemove = (e) => {
    e.preventDefault();
    if (onDrag.value) {
        // 当前鼠标距离左侧浏览器的距离
        let pageX = e.pageX;
        // 圆点的定位left
        let PointerLeft = 0;
        PointerLeft = pageX - scoreRulerOffsetX.value;
        // 每分值所占的平均宽度
        let average = rulerWidth.value / +props.score;
        // 计算分值
        valueData.value = Math.round(PointerLeft / average);
        // 分值所占整个宽度百分比
        let percent = (PointerLeft / rulerWidth.value).toFixed(2);
        // 当距离和 标尺 距离浏览器距离相等时
        if (pageX <= scoreRulerOffsetX.value) {
            PointerLeft = 0;
            // 分值最小
            valueData.value = 0;
            percent = 0;
        }
        if (pageX + 30 >= scoreRulerOffsetX.value + rulerWidth.value) {
            // 当距离  > 标尺距离左侧距离 + 标尺长度时，left = 标尺长度
            PointerLeft = rulerWidth.value - 30;
            // 分值最大
            valueData.value = props.score;
            percent = 1;
        }

        // 进度条
        scoreRulerBar.value.style.width = percent * 100 + "%";
        // 圆点
        scoreRulerPointer.value.style.left = PointerLeft + "px";
    }
};
window.onmouseup = (e) => {
    onDrag.value = false;
};
</script>
<style lang="scss" scoped>
.score-ruler {
    width: 550px;
    height: 10px;
    border-radius: 11px;
    background: rgba(228, 229, 232, 1);
    position: relative;
    margin-top: 30px;
    .bar {
        width: 0%;
        height: 100%;
        border-radius: 11px;
        background-color: rgb(34, 64, 195);
    }
    .bar-pointer {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        cursor: pointer;
        .score-show {
            width: 30px;
            height: 20px;
            line-height: 20px;
            background-color: rgb(34, 64, 195);
            position: absolute;
            top: -9px;
            right: 0;
            transform: translateY(-100%);
            text-align: center;
            color: #fff;
            border-radius: 5px;
            &-arrow {
                width: 10px;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 5px solid rgb(34, 64, 195);
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%, 100%);
            }
        }
    }
}
</style>
